import { checkoutInfoQuery } from '../../hooks'
import { queryClient } from '../../state'
import { PaymentRouteLoader } from './payment-route.types'

const NOT_WORKFLOW = 0

export const paymentRouteLoader: PaymentRouteLoader = async ({ request }) => {
  const url = new URL(request.url)
  const session = url.searchParams.get('session')

  if (
    session &&
    !queryClient.getQueryData(checkoutInfoQuery(session).queryKey)
  ) {
    const checkoutInfo = await queryClient.fetchQuery(checkoutInfoQuery(session))

    if (checkoutInfo.workflow.length === NOT_WORKFLOW) {
      throw new Error('Error')
    }
    return checkoutInfo.workflow
  }

  return null
}
